import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import translationEN from './assets/locales/en/translation.json'
import translationFR from './assets/locales/fr/translation.json'
import translationIT from './assets/locales/it/translation.json'

const resources = {
	en: {
		translation: translationEN,
	},
	fr: {
		translation: translationFR,
	},
	it: {
		translation: translationIT,
	},
}

i18n.use(initReactI18next).init({
	resources,
	fallbackLng: 'fr',
	order: ['navigator', 'localStorage'],
	debug: false,
	interpolation: {
		escapeValue: false,
	},
})

export default i18n
